import React, { Component } from 'react';
import BoxInputFieldComponent from './BoxInputFieldComponent';
import { PropTypes } from 'prop-types';
import _ from 'lodash';
import { RADIO } from '../constants';

class RadioInputFieldComponent extends Component {
    validateDefault = value =>
        this.props.isRequired && _.isNil(value) ? this.props.i18nFeatureForm.OPTION_REQUIRED : '';

    handleOnChange = event => event.target.value;

    handleChecked = (currentValue, optionValue, type) => currentValue === _.toString(optionValue);

    getInputValue = (input, type) => (input.value ? input.value : null);

    getInputName = (input, index, type) => input.name;

    render() {
        const { validate } = this.props;
        return (
            <BoxInputFieldComponent
                {...this.props}
                typeBox={RADIO}
                validate={validate ? validate : this.validateDefault}
                handleOnChange={this.handleOnChange}
                handleChecked={this.handleChecked}
                getInputName={this.getInputName}
                getInputValue={this.getInputValue}
            />
        );
    }
}

// See proptypes in ./BoxInputFieldComponent.js for global Field props
BoxInputFieldComponent.propTypes = {
    isRequired: PropTypes.bool
};

export default RadioInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/boxInput/RadioInputFieldComponent.js